/**
 * 必填项管理
 * @author wumz
 * @date 2020-09-07
 */
import request from '@/utils/request'

// 获取表单
export function findByFieldFrom(query) {
  return request({
    url: `/ntocc-basic-api/fieldRequiredSetting/findByFieldFrom`,
    method: 'get',
    params: query
  })
}

// 保存必填设置
export function updateFieldRequired(query) {
  return request({
    url: `/ntocc-basic-api/fieldRequiredSetting/updateFieldRequired`,
    method: 'post',
    data: query
  })
}